import React, { useState, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import GetAppIcon from "@material-ui/icons/GetApp"
import { green, red } from "@material-ui/core/colors"
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline"
import { Button, FormControl, CircularProgress, Typography } from "@material-ui/core"
import { getGetSignedUrl, fetchFile, getMegafileTime } from "../api/apiCalls"
import { UserContext } from "../contexts/UserContext"
import { HistoryContext } from "../contexts/HistoryContext"
import { MessagingContext } from "../contexts/MessagingContext"

const useStyles = makeStyles((theme) => ({
  card: {
    "& > *": {
      margin: theme.spacing(1),
    },
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  error: {
    color: red[500],
  },
  successMessage: {
    color: green[500],
    fontSize: "0.8em",
    marginTop: 10,
    maxWidth: 300,
  },
  input: {
    display: "none",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  button: {
    minWidth: 300,
    color: "white",
    maxWidth: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonDisabled: {
    color: "rgba(0,0,0,0.2)",
  },
  done: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonProgressValue: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -9,
    marginLeft: -7,
  },
  wrapper: {
    position: "relative",
  },
  quarterRadioLabel: {
    marginTop: 10,
  },
}))

const DownloadFileButton = ({ label, disabled, callBack, context }) => {
  const [gettingHistory, setGettingHistory] = useState(false)
  const [transferring, setTransferring] = useState(false)
  const [progress, setProgress] = useState(0)
  const [error, setError] = useState()
  const classes = useStyles()
  const { user } = useContext(UserContext)
  const { history, fetchHistory, saveActivity, saveError } = useContext(
    HistoryContext
  )
  const { addSuccessMessage, addErrorMessage } = useContext(MessagingContext)

  const progressCallback = (progress) => {
    progress = progress.toString()

    if (progress !== "" && progress.length < 2) {
      progress = `0${progress}`
    }
    setProgress(progress)
  }

  const completionCallback = async () => {
    setTransferring(false)
    setProgress(0)
    console.log("CONTEXT", context)
    let downloadName =
      context === "megafile" ? "capone_megafile.csv" : `${context}_template.xlsx`
    addSuccessMessage("DOWNLOAD", `${downloadName} Download Complete`)
    await saveActivity(user, downloadName, false, context)
    fetchHistory(user)
  }

  const errorCallback = async (error) => {
    console.log(error)
    setTransferring(false)
    let downloadName =
      context === "megafile" ? "capone_megafile.csv" : `${context}_template.xlsx`
    addErrorMessage("DOWNLOAD ERROR", `${downloadName} Not Found`)
    await saveError(user, downloadName, context === "megafile", context)
    fetchHistory(user)
  }

  const downloadDefaultTemplate = async () => {
    console.log(" GETTING LAST EST NAME: ", getLastEstimateName())
    const downloadName = getLastEstimateName()
    getGetSignedUrl(user, "uploaded", "defaultestimate", getLastEstimateName()).then(
      ({ url }) => {
        fetchFile(
          url,
          downloadName,
          progressCallback,
          completionCallback,
          errorCallback
        )
      }
    )
  }

  const downloadTemplate = async () => {
    setTransferring(true)

    if (context !== "defaultestimate") {
      const downloadName =
        context === "megafile" ? "capone_megafile.csv" : `${context}_template.xlsx`

      getGetSignedUrl(user, "downloads", context, "template.xlsx").then(
        ({ url }) => {
          fetchFile(
            url,
            downloadName,
            progressCallback,
            completionCallback,
            errorCallback
          )
        }
      )
    } else {
      setGettingHistory(true)
      fetchHistory(user)
    }
  }

  useEffect(() => {
    console.log(
      " context === 'defaultestimate' && gettingHistory && history ",
      context,
      gettingHistory,
      history
    )
    if (context === "defaultestimate" && gettingHistory && history.length) {
      downloadDefaultTemplate()
      setGettingHistory(false)
    }
  }, [history])

  const getLastEstimateName = () => {
    let returnStr = history.filter((item) => {
      return item.context === context && item.activity_type_id === 1
    })
    console.log(" ITEM  ", returnStr)
    if (returnStr && returnStr[0] && returnStr[0].new_filename)
      return returnStr[0].new_filename
    return ""
  }

  return (
    <FormControl className={classes.formControl}>
      <Button
        className={classes.button}
        style={{ opacity: transferring ? "0.2" : "1.0" }}
        variant={transferring ? "outlined" : "contained"}
        color="secondary"
        disableElevation
        disabled={disabled || transferring}
        onClick={downloadTemplate}
        startIcon={<GetAppIcon />}
      >
        {label}
      </Button>
      {context === "defaultestimate" && (
        <span>latest file: {getLastEstimateName()}</span>
      )}
      {transferring && (
        <>
          {progress === "100" ? (
            <CheckCircleOutlineIcon size={24} className={classes.done} />
          ) : (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
          <Typography
            className={classes.buttonProgressValue}
            variant="caption"
            component="div"
            color="textSecondary"
          >
            {progress !== "100" && progress}
          </Typography>
        </>
      )}
      {error && <div className={classes.error}>{error}</div>}
    </FormControl>
  )
}

DownloadFileButton.propTypes = {
  fileName: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  callBack: PropTypes.func,
  context: PropTypes.string,
}

export default DownloadFileButton
